import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { GetDrawDownRepaymentScheduleCreditFacilityResponse } from '@iwoca/lapi-client/edge';
import { Pill } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import {
    Table,
    TableHeader,
    TableCell,
    TableBody,
    TableHead,
    TableRow
} from '@ui';
import { FormattedDate, FormattedMessage } from 'react-intl';

export const RepaymentFreePeriodHeader = ({
    isInRepaymentFreePeriod
}: {
    isInRepaymentFreePeriod?: boolean;
}) => {
    return (
        <div className="space-y-xs rounded-t-m bg-secondary-95 p-l">
            <h3 className="my-0 inline-flex gap-s">
                <FormattedMessage
                    id="_.rcf_approved_view.repayment_free_period_heading"
                    defaultMessage="Repayment-free period"
                />
                {isInRepaymentFreePeriod && (
                    <Pill variant="green">
                        <FormattedMessage
                            id="_.rcf_approved_view.you_are_here_pill"
                            defaultMessage="You are here"
                        />
                    </Pill>
                )}
            </h3>
            <Text data-testid="repayment-free-period-description">
                <FormattedMessage
                    id="_.rcf_approved_view.repayment_free_period_description"
                    defaultMessage="You pay interest only on the outstanding loan amount for 12 months."
                />
            </Text>
        </div>
    );
};

export const RepaymentFreePeriodTable = ({
    schedule
}: {
    schedule: GetDrawDownRepaymentScheduleCreditFacilityResponse['data']['schedule'];
}) => {
    return (
        <div className="rounded-b-l bg-secondary-95">
            <Table
                className="border-separate border-structure-80"
                title="Repayment-free period table"
            >
                <TableHeader className="bg-secondary-95">
                    <TableRow>
                        <TableHead>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_schedule_table_date"
                                defaultMessage="Date"
                            />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_schedule_table_principal"
                                defaultMessage="Principal"
                            />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_schedule_table_interest"
                                defaultMessage="Interest"
                            />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_schedule_table_total"
                                defaultMessage="Total Repayment"
                            />
                        </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {schedule.map((repayment, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <FormattedDate value={repayment.date} />
                            </TableCell>
                            <TableCell>
                                <FormattedCurrency
                                    value={repayment.principal}
                                />
                            </TableCell>
                            <TableCell>
                                <FormattedCurrency value={repayment.interest} />
                            </TableCell>
                            <TableCell>
                                <FormattedCurrency value={repayment.total} />
                                {index === 0 ? (
                                    <span className="block text-xs font-reg">
                                        <FormattedMessage
                                            id="_.rcf_approved_view.repayment_free_period_table_product_fee"
                                            defaultMessage="incl. {fee} fee"
                                            values={{
                                                fee: (
                                                    <FormattedCurrency
                                                        value={
                                                            repayment.total_fees
                                                        }
                                                    />
                                                )
                                            }}
                                        />
                                    </span>
                                ) : null}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
